import { DateTime } from 'luxon';

// endsOn is an absolute instant, so it's rendered in whichever zone is asked
// for (defaulting to the viewer's browser zone) with the zone abbreviation, so
// it's never ambiguous which clock the time refers to.
const formatMaintenanceEnd = ({
  endsOn,
  zone,
  isTimeOnly,
}: {
  endsOn: string;
  zone?: string;
  isTimeOnly?: boolean;
}) => {
  const dateTime = zone
    ? DateTime.fromISO(endsOn).setZone(zone)
    : DateTime.fromISO(endsOn);

  return dateTime.toFormat(
    isTimeOnly ? 'h:mm a ZZZZ' : 'ccc d LLL yyyy, h:mm a ZZZZ',
  );
};

export const getLocalZoneName = () => DateTime.local().zoneName;

export default formatMaintenanceEnd;
